const Form: React.FC = () => {
  return (
    <section id="sweptbooks-form" className="my-5">
      <form
        action="https://formsubmit.co/contact@sweptbooks.com"
        method="POST"
        className="border border-black border-1 rounded p-4 shadow"
      >
        <input type="hidden" name="_captcha" value="false" />
        <input
          type="hidden"
          name="_subject"
          value="New Website Contact Form Submission"
        />
        <input
          type="hidden"
          name="_next"
          value="https://yourdomain.com/thank-you"
        />

        <p>
          Name <span>(required)</span>
        </p>

        <div className="d-flex justify-content-between mb-2">
          <div className="d-flex flex-column flex-grow-1 me-3">
            <label htmlFor="fname">First Name</label>
            <input
              type="text"
              id="fname"
              name="fname"
              className="form-control"
              required
            />
          </div>

          <div className="d-flex flex-column flex-grow-1">
            <label htmlFor="lname">Last Name</label>
            <input
              type="text"
              id="lname"
              name="lname"
              className="form-control"
              required
            />
          </div>
        </div>

        <div className="d-flex flex-column mb-2">
          <label htmlFor="email">
            Email <span>(required)</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            className="form-control"
            required
          />
        </div>

        <div className="form-group d-flex flex-column mb-3">
          <label htmlFor="message">
            Message <span>(required)</span>
          </label>
          <textarea
            name="message"
            id="message"
            className="w-100 form-control"
            required
          ></textarea>
        </div>

        <input type="submit" value="Submit" className="btn btn-primary" />
      </form>
    </section>
  );
};

export default Form;
